<template>
  <v-layout row wrap>
    <v-flex
      md6
      pa-2
      sm12
      xl4
      xs12
    >
      <v-card>
        <v-form
          lazy-validation
          ref="form"
          v-model="valid"
        >
          <v-toolbar>
            <v-toolbar-title>{{label}} {{prototypeValue.name}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              :counter="100"
              :rules="nameRules"
              label="Title"
              required
              v-model="prototypeValue.title"
            ></v-text-field>
            <v-text-field
              :counter="100"
              :rules="descriptionRules"
              label="Description"
              required
              v-model="prototypeValue.description"
            ></v-text-field>
            <v-select
              v-model="prototypeValue.owner"
              :items="users"
              :rules="userRules"
              item-text="name"
              item-value="id"
              label="Owner"
            ></v-select>
            <v-select
              v-model="prototypeValue.sprint"
              :items="sprints"
              item-text="name"
              item-value="id"
              label="Sprint"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!valid"
              @click="submit"
              color="success"
            >
              Save
            </v-btn>
            <v-btn
              @click="reset"
              color="error"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>

export default {
  name: 'StoryEditFields',
  props: ['value', 'type'],
  data: () => ({
    valid: true,
    prototypeValue: {},
  }),
  computed: {
    label: {
      get() {
        return this.type.charAt(0)
          .toUpperCase() + this.type.slice(1);
      },
    },
    users() {
      return this.$store.getters.getUsers;
    },
    sprints() {
      return this.$store.getters.getSprints;
    },
    nameRules() {
      return [
        v => !!v || 'Title is required',
        v => (v && v.length <= 100) || 'Title must be less than 100 characters',
      ];
    },
    descriptionRules() {
      return [
        v => !!v || 'Description is required',
      ];
    },
    userRules() {
      return [
        v => ((this.prototypeValue.sprint != null) ? !!v : true) || 'User is required',
      ];
    },
  },
  methods: {
    submit() {
      if (this.prototypeValue.owner !== undefined) {
        this.prototypeValue.status = 'ToDo';
        this.prototypeValue.done_at = null;
      }
      if (this.$refs.form.validate()) {
        this.$emit('input', this.prototypeValue);
      }
    },
    reset() {
      this.initForm();
    },
    initForm() {
      this.prototypeValue = this.value;
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>
